module.exports = __webpack_public_path__ + "static/media/revthomas.fb8d83fe.svg";